module.exports = ".ck .funcao.ck-widget{user-select:none}"